module.exports = __webpack_public_path__ + "img/37845-081.e291c7d5.jpg";